<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ editar ? 'Editar Importes' : 'Editar Importes' }}</span>
        </v-card-title>

        <v-card-text>
            <v-alert
                    v-model="mostrar_alert"
                    dismissible
                    :type="type_alert"
            >
                <template v-html="html_alert"/>
            </v-alert>

            <v-container grid-list-md>
                <v-layout row>
                    <v-flex xs12 sm6>
                        <v-text-field
                                :value="form.importe_referidor"
                                :error-messages="error_input.importe_referidor"
                                label="Importe Referidor"
                                @input="(payload) => form.importe_referidor = payload"
                        />
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                                :value="form.importe_referido"
                                :error-messages="error_input.importe_referido"
                                label="Importe Referido"
                                @input="(payload) => form.importe_referido = payload"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                    color="gray darken-1"
                    @click="close"
            >
                Cancelar
            </v-btn>
            <v-btn
                    color="blue darken-1"
                    class="white--text"
                    :loading="loading"
                    :disabled="loading"
                    @click="guardar"
            >
                Guardar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';

    import EventBus from "../EventBus";

    export default {
        name: "FormImportesReferenciados",
        props: {
            idItem: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                active: null,
                form: {
                    id: 0,
                    importe_referenciador: '',
                    importe_referenciado: ''
                },
                error_input: {},
                loading: false,
                loading_codigo:false,
                mostrar_alert: false,
                type_alert: 'success',
                html_alert: '',
            }
        },
        computed: {
            editar() {
                return this.idItem > 0;
            }
        },
        watch: {},
        mounted() {
            this.verCodigoReferencia();
        },
        methods: {
            close() {
                this.$emit('close', true);
            },
            guardar() {
                let url_target = this.editar ? '/api/codigo_referencia_historial/actualizar/' + this.idItem : '/api/codigo_referencia_historial/actualizar/';
                this.loading = true;
                axios.post(url_target, this.form)
                    .then((success) => {
                        let {data} = success;
                        /*window.console.log('IsData', data);*/
                        if (data.success) {
                            EventBus.$emit('tugarrafon:show-snackbar', {
                                color: 'success',
                                text_content: 'Importes actualizados correctamente'
                            });
                            this.$emit('save', data.message);
                        }
                    })
                    .catch((error) => {

                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
                            if (error.response.status === 422) {
                                /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
                                EventBus.$emit('tugarrafon:show-snackbar', {
                                    color: 'error',
                                    text_content: error.response.data.message
                                });
                                this.error_input = Object.assign({}, error.response.data.data)
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            /*window.console.log(error.request);*/
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            /*window.console.log('Error', error.message);*/
                        }
                    }).finally(()=>{
                    this.loading = false;
                })
            },
            verCodigoReferencia() {
                this.loading = true;
                axios.get('/api/codigo_referencia_historial/ver/' + this.idItem)
                    .then(({data}) => {
                        this.form = Object.assign({}, data.data);
                    }).finally(()=>{
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
